import { useState } from 'react';

const usePagination = (fetchFunction, baseUrl) => {
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    currentPage: 1,
  });

  const updatePagination = (data) => {
    setPagination({
      count: data.count,
      next: data.next,
      previous: data.previous,
      currentPage: data.currentPage || 1, // Use provided currentPage or default to 1
    });
  };

  const fetchNext = async () => {
    if (pagination.next) {
      await fetchFunction(pagination.next);
      setPagination((prev) => ({
        ...prev,
        currentPage: prev.currentPage + 1, // Move to next page
      }));
    }
  };

  const fetchPrevious = async () => {
    if (pagination.previous) {
      await fetchFunction(pagination.previous);
      setPagination((prev) => ({
        ...prev,
        currentPage: prev.currentPage - 1, // Move to previous page
      }));
    }
  };

  const goToPage = async (pageNumber) => {
    const url = `${baseUrl}?page=${pageNumber}`;
    await fetchFunction(url);
    setPagination((prev) => ({
      ...prev,
      currentPage: pageNumber, // Update the current page
    }));
  };

  return { pagination, updatePagination, fetchNext, fetchPrevious, goToPage };
};

export default usePagination;
